<template>
  <div class="container-fluid">
    <div class="function-card">
      <button type="button" class="btn btn-primary" @click="addTemplate">
        {{ i18n("Buttons.Create") }}
      </button>
    </div>
    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="CreateTime" slot-scope="props">
          <div>
            <span v-if="props.row.CreateTime">
              {{ $common.dateTimeFormatter(props.row.CreateTime) }}
            </span>
          </div>
        </template>
        <template slot="UpdateTime" slot-scope="props">
          <div>
            <span v-if="props.row.UpdateTime">
              {{ $common.dateTimeFormatter(props.row.UpdateTime) }}
            </span>
          </div>
        </template>

        <template slot="copy" slot-scope="props">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="copyTemplate(props.row.MailTemplateGuid)"
          >
            複製
          </button>
        </template>
        <template slot="edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            @click="editTemplate(props.row)"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#deleteModal"
            @click="deleteItem = props.row"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!--刪除 Modal-->
    <div
      id="deleteModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ i18n("Template.DeleteTemplate") }}</span>
          </div>
          <div class="modal-body">
            確認刪除<span style="font-weight: bolder; color: red">
              {{ deleteItem.MailTemplateName }}</span
            >
            ?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delMailTemplate"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "HireLetter",

  data() {
    return {
      LetterGuid: "",
      LetterName: "錄取通知",

      // 刪除資訊
      deleteItem: {},

      // 分頁資訊
      totalData: 0,
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      // table
      rows: [],
      columns: [
        {
          label: this.i18n("Basic.Department"),
          name: "DepartmentName",
        },
        {
          label: this.i18n("Template.TemplateName"),
          name: "MailTemplateName",
        },
        {
          label: this.i18n("Basic.CreateTime"),
          name: "CreateTime",
          slot_name: "CreateTime",
        },
        {
          label: this.i18n("Basic.CreateUser"),
          name: "CreateUser",
        },
        {
          label: this.i18n("Template.LatestUpdateTime"),
          name: "UpdateTime",
          slot_name: "UpdateTime",
        },
        {
          label: this.i18n("Basic.UpdateUser"),
          name: "UpdateUser",
        },
        {
          label: "",
          slot_name: "copy",
        },
        {
          label: "",
          slot_name: "edit",
        },
        {
          label: "",
          slot_name: "delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getMailTemplate();
    },

    // 取得 錄取通知範本
    getMailTemplate() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .getMailTemplatePaging(
          {
            isPaging: true,
            page: this.tableInfo.page,
            perPage: this.tableInfo.per_page,
          },
          "Hired"
        )
        .then((response) => {
          if (response.status === 200) {
            this.LetterGuid = response.data.MailCategoryGuid;
            this.rows = response.data.Datas;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 複製 錄取通知範本
    copyTemplate(mailTemplateGuid) {
      this.updateLoading(true);
      this.$api.mailTemplate
        .copyMailTemplate({
          MailTemplateGuid: mailTemplateGuid,
          CreateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "範本複製成功",
              type: "success",
              duration: 2000,
            });
            this.getMailTemplate();
          }
          this.updateLoading(false);
        });
    },

    // 新增
    addTemplate() {
      this.$store.commit("Letter", this.LetterGuid);
      this.$store.commit("LetterName", this.LetterName);
      this.$router.push({
        name: "範本維護,新增信件範本",
      });
    },

    // 編輯
    editTemplate(item) {
      this.$store.commit("Letter", this.LetterGuid);
      this.$store.commit("LetterName", this.LetterName);
      this.$store.commit("LetterGuid", item.MailTemplateGuid);
      this.updateLoading(true);
      this.$router.push({
        name: "範本維護,編輯信件範本",
      });
    },

    // 刪除 錄取通知信範本
    delMailTemplate() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .deleteMailTemplate(this.deleteItem.MailTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "範本刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getMailTemplate();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(['updateLoading']),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    }
  },

  computed: {
    ...mapGetters(["lang"]),
  },

  watch: {
    lang: function () {
      this.columns = [
        { label: this.i18n("Basic.Department"), name: "DepartmentName" },
        { label: this.i18n("Template.TemplateName"), name: "MailTemplateName" },
        {
          label: this.i18n("Basic.CreateTime"),
          name: "CreateTime",
          slot_name: "CreateTime",
        },
        { label: this.i18n("Basic.CreateUser"), name: "CreateUser" },
        {
          label: this.i18n("Template.LatestUpdateTime"),
          name: "UpdateTime",
          slot_name: "UpdateTime",
        },
        { label: this.i18n("Basic.UpdateUser"), name: "UpdateUser" },
        {
          label: "",
          slot_name: "copy",
        },
        { label: "", slot_name: "edit" },
        { label: "", slot_name: "delete" },
      ];
    },
  },
};
</script>